import React, { LegacyRef, useCallback, useEffect, useRef, useState } from 'react';
import { FlatList, TouchableOpacity, Text } from 'react-native';
import { useFocusEffect } from 'expo-router';
import { usePersistBoundStore } from '@/services/zustand/Store';
import { useFetchLiveMagazines } from '@/services/FetchMagazines';
import ListItem_Magazine from './ListItem_Magazine';
import { useFilterMagazines } from '@/services/PDF/filterMagazines';
import { useHandleSelectMagazine } from '@/services/PDF/useHandleSelectMagazine';
import dayjs from 'dayjs';
import { Magazine } from '@/services/datatypes/pdf';

export default function Selector() {
  const [availableMagazines, setAvailableMagazines] = useState<Magazine[]>([]);
  const [editionFilter, setEditionFilter] = useState<string | null>(null);
  const [dateFilter, setDateFilter] = useState<string | null>(null);
  const favouriteEdition = usePersistBoundStore((state) => state.favouriteEdition);
  const selectedDate = usePersistBoundStore((state) => state.selectedDate);
  const updateSelectedDate = usePersistBoundStore((state) => state.updateSelectedDate);
  const handleSelect = useHandleSelectMagazine();
  const fetchLiveMagazines = useFetchLiveMagazines();
  const filteredMagazines = useFilterMagazines(availableMagazines || [], dateFilter, editionFilter);
  const flatListref = useRef<FlatList<Magazine>>();

  useFocusEffect(
    useCallback(() => {
      //console.log("Selector.tsx - useFocusEffect");
      const prepare = async () => {
        const magazines = await fetchLiveMagazines();
        setAvailableMagazines(magazines);
      };
      prepare();
    }, [])
  );

  useEffect(() => {
    //console.log("Selector.tsx - selectedDate updated");
    if (selectedDate) {
      //console.log("Selector.tsx - selectedDate: ", selectedDate, typeof (selectedDate));
      setDateFilter(selectedDate);
      updateSelectedDate(null);
    }
  }, [selectedDate])

  useEffect(() => setEditionFilter(favouriteEdition), [favouriteEdition]);
  const clearfilters = () => setDateFilter(null);

  const handleLoadMore = () => {
    if (dateFilter) {
      let newDateFilter: string;
      //console.log(dateFilter);
      newDateFilter = dayjs(dateFilter).subtract(7, 'day').format('YYYYMMDD');
      setDateFilter(newDateFilter);
    }
  }

  const renderItem = ({ item, index }: { item: Magazine, index: number }) => (
    <ListItem_Magazine
      index={index}
      magazine={item}
      handleButtonPress={handleSelect}
    />
  );

  useEffect(() => {
    //console.log(dateFilter)
    if (flatListref.current && filteredMagazines.length > 0) {
      flatListref.current.scrollToIndex({ index: 0, animated: true });
    }
  }, [dateFilter])

  return (
    <>
      <FlatList
        ref={flatListref as LegacyRef<FlatList<Magazine>>}
        data={filteredMagazines}
        renderItem={renderItem}
        keyExtractor={(item, index) => index.toString()}
        ListFooterComponent={(
          <>
            <TouchableOpacity style={{ alignSelf: 'center' }} onPress={handleLoadMore}>
              <Text style={{ backgroundColor: '#069', margin: 15, padding: 15, borderRadius: 5, fontSize: 26, color: '#fff' }}>mehr laden</Text>
            </TouchableOpacity>
            {(dateFilter != dayjs().format('YYYYMMDD')) && (
              <TouchableOpacity style={{ alignSelf: 'center' }} onPress={clearfilters}>
                <Text style={{ backgroundColor: '#069', margin: 15, padding: 15, borderRadius: 5, fontSize: 26, color: '#fff' }}>Filter löschen</Text>
              </TouchableOpacity>
            )}
          </>
        )}
      />

    </>
  );
}

